import * as z from 'zod';

// Types
import { TextZod } from '@/components/molecules/Text/TextType';
import { TitleZod } from '@/types/TitleType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';
import { ParagraphZod } from '@/components/atoms/Paragraph/ParagraphType';

const TextAccordionZod = z.object({
  __component: z.literal('block.text-accordion'),
  id: z.number(),
  text: TextZod,
  accordions: z.array(
    z.object({
      id: z.number(),
      title: TitleZod,
      paragraph: ParagraphZod,
    }),
  ),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { TextAccordionZod };
export type TextAccordionType = z.infer<typeof TextAccordionZod>;
